/* eslint-disable */
import httpClient from '@/utils/httpClient'
import {
  GetExternalApiCredentialsSettingsResponse,
  SetupAtimoCredentialsSettingsRequest,
  UpdateDrivematicsAPICredentialsRequest,
  UpdateDrivematicsAPICredentialsResponse,
  UpdateMozenParkTokenRequest,
  UpdateWialonAPICredentialsRequest,
  UpdateWialonAPICredentialsResponse
} from 'rikroot-types/parksmanagement/external_api_credentials_settings.pb'
// import {
//   GetCarBlockingRulesResponse,
//   UpdateCarBlockingRulesRequest,
//   UpdateCarBlockingRulesResponse
// } from 'rikroot-types/parksmanagement/settings.pb'

export class ExternalApiCredsSettingsRepo extends httpClient {
  public async getExternalApiCredentialsSettings (): Promise<GetExternalApiCredentialsSettingsResponse | undefined> {
    const data = await this.get('/park_management/settings/external_api_credentials')
    return data as GetExternalApiCredentialsSettingsResponse
  }

  public async changeAtimoCredentials (req: SetupAtimoCredentialsSettingsRequest): Promise<void> {
    await this.post('/park_management/settings/atimo_api_credentials', req)
  }

  public async changeMozenCredentials (req: UpdateMozenParkTokenRequest): Promise<void> {
    await this.put('/park_management/settings/mozen_api_credentials', req)
  }

  public async changeWialonCredentials (req: UpdateWialonAPICredentialsRequest): Promise<UpdateWialonAPICredentialsResponse> {
    return await this.put('/park_management/settings/wialon_api_credentials', req)
  }

  public async changeYandexDrivematicsCredentials (req: UpdateDrivematicsAPICredentialsRequest): Promise<UpdateDrivematicsAPICredentialsResponse> {
    return await this.put('/park_management/settings/drivematics_api_credentials', req)
  }

  public async fetchCarBlockingRules (): Promise<any> {
    return await this.get('/park_management/settings/car_blocking_rules')
  }

  public async changeCarBlockingRules (req: any): Promise<any> {
    return await this.put('/park_management/settings/car_blocking_rules', req)
  }
}
